export enum FieldRuleValidationType {
    equalTo = 1,
    notEqualTo = 2,
    isOneOf = 3,
    isNotOneOf = 4,
    containsAnyOf = 5,
    containsAllOf = 6,
    containsNoneOf = 7,
    equalsInAnyOrder = 8,
    isNotEmpty = 9,
    startsWith = 10,
    contains = 11,
    notContains = 12,
    isChecked = 13,
}
